import { Block, BlockSchema } from './Block.types';

import { BlockType, NaiveBookMeetingBlockConfigSchema } from './blockConfig/Types';

import { z } from 'zod';

export const NaiveBookMeetingBlockSchema = BlockSchema.extend({
  blockConfig: NaiveBookMeetingBlockConfigSchema,
});
export type NaiveBookMeetingBlock = z.infer<typeof NaiveBookMeetingBlockSchema>;

export function isNaiveBookMeetingBlock(block: Block): block is NaiveBookMeetingBlock {
  return block.blockConfig.type === BlockType.NaiveBookMeeting;
}
